import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Architecture from "../pages/architecture/page";
import Deduplication from "../pages/deduplication/page";
import VergeFS from "../pages/vergefs/page";
import VergeFabric from "../pages/vergefabric/page";
import InfrastructureAutomation from "../pages/infrastructure-automation/page";
import VergeIQ from "../pages/vergeiq/page";
import VirtualDataCenters from "../pages/virtual-data-centers/page";
import HighAvailability from "../pages/high-availability/page";
import IoClone from "../pages/ioclone/page";
import IoReplicate from "../pages/ioreplicate/page";
import IoFortify from "../pages/iofortify/page";
import IoMigrate from "../pages/iomigrate/page";
import IoProtect from "../pages/ioprotect/page";
import IoOptimize from "../pages/iooptimize/page";
import IoGuardian from "../pages/ioguardian/page";
import VMwareAlternative from "../pages/vmware-alternative/page";
import HCI from "../pages/hci/page";
import SANReplacement from "../pages/san-replacement/page";
import InfrastructureModernization from "../pages/infrastructure-modernization/page";
import VirtualDesktop from "../pages/virtual-desktop/page";
import SecureResearchComputing from "../pages/secure-research-computing/page";
import EdgeROBO from "../pages/edge-robo/page";
import BlogPage from "../pages/blog/page";
import StorageRefreshPage from "../pages/blog/StorageRefreshPage";
import RamTuketimiPage from "../pages/blog/RamTuketimiPage";
import VmYogunlukPage from "../pages/blog/VmYogunlukPage";
import FelaketKurtarmaPage from "../pages/blog/FelaketKurtarmaPage";
import KolayVmwarePage from "../pages/blog/KolayVmwarePage";
import VmwareKriterlerPage from "../pages/blog/VmwareKriterlerPage";
import VmwareOzelBulutPage from "../pages/blog/VmwareOzelBulutPage";
import OzelBulutOsPage from "../pages/blog/OzelBulutOsPage";
import VxRailPage from "../pages/blog/VxRailPage";
import YerindVmwarePage from "../pages/blog/YerindVmwarePage";
import DemoPage from "../pages/demo/page";
import VersionsPage from "../pages/versions/page";
import TestDrivePage from "../pages/test-drive/page";
import IletisimPage from "../pages/iletisim/page";
import OzelBulutOSPage from "../pages/ozel-bulut-os/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/architecture", element: <Architecture /> },
  { path: "/deduplication", element: <Deduplication /> },
  { path: "/vergefs", element: <VergeFS /> },
  { path: "/vergefabric", element: <VergeFabric /> },
  { path: "/infrastructure-automation", element: <InfrastructureAutomation /> },
  { path: "/vergeiq", element: <VergeIQ /> },
  { path: "/virtual-data-centers", element: <VirtualDataCenters /> },
  { path: "/high-availability", element: <HighAvailability /> },
  { path: "/ioclone", element: <IoClone /> },
  { path: "/ioreplicate", element: <IoReplicate /> },
  { path: "/iofortify", element: <IoFortify /> },
  { path: "/iomigrate", element: <IoMigrate /> },
  { path: "/ioprotect", element: <IoProtect /> },
  { path: "/iooptimize", element: <IoOptimize /> },
  { path: "/ioguardian", element: <IoGuardian /> },
  { path: "/vmware-alternative", element: <VMwareAlternative /> },
  { path: "/hci", element: <HCI /> },
  { path: "/san-replacement", element: <SANReplacement /> },
  { path: "/infrastructure-modernization", element: <InfrastructureModernization /> },
  { path: "/virtual-desktop", element: <VirtualDesktop /> },
  { path: "/secure-research-computing", element: <SecureResearchComputing /> },
  { path: "/edge-robo", element: <EdgeROBO /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/storage-yenileme-maliyeti-2026", element: <StorageRefreshPage /> },
  { path: "/blog/ram-tuketimi-azaltma", element: <RamTuketimiPage /> },
  { path: "/blog/vm-yogunluk-patlama-yaricapi", element: <VmYogunlukPage /> },
  { path: "/blog/felaket-kurtarma-roi", element: <FelaketKurtarmaPage /> },
  { path: "/blog/kolay-vmware-alternatifi", element: <KolayVmwarePage /> },
  { path: "/blog/vmware-alternatifleri-kriterler", element: <VmwareKriterlerPage /> },
  { path: "/blog/vmwareden-ozel-buluta", element: <VmwareOzelBulutPage /> },
  { path: "/blog/ozel-bulut-os-nedir", element: <OzelBulutOsPage /> },
  { path: "/blog/vxrail-alternatifleri", element: <VxRailPage /> },
  { path: "/blog/yerinde-vmware-cikisi", element: <YerindVmwarePage /> },
  { path: "/demo", element: <DemoPage /> },
  { path: "/versions", element: <VersionsPage /> },
  { path: "/test-drive", element: <TestDrivePage /> },
  { path: "/iletisim", element: <IletisimPage /> },
  { path: "/ozel-bulut-os", element: <OzelBulutOSPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
